const useHasOtherPrimaryButtonForTemplate = () => false;

export default useHasOtherPrimaryButtonForTemplate;
